export default __webpack_public_path__ + "static/media/ctnews-feature-graphic.cde91e10.png";